var exports = {
  "kL": "ChannelInvitesTab.module__container___ZFFtX3",
  "wx": "ChannelInvitesTab.module__header___ZFFtX3",
  "h_": "ChannelInvitesTab.module__description___ZFFtX3",
  "GC": "ChannelInvitesTab.module__buttonGroup___ZFFtX3",
  "dc": "ChannelInvitesTab.module__spinnerContainer___ZFFtX3",
  "sJ": "ChannelInvitesTab.module__invitesContainer___ZFFtX3",
  "$h": "ChannelInvitesTab.module__invitesList___ZFFtX3",
  "eu": "ChannelInvitesTab.module__inviteItems___ZFFtX3",
};

module.exports = exports;
